export const BASE_SELECTOR = "[txu-handler]";
export const DISABLE_VALUE_SELECTOR = "[txu-handler='disable-checkbox']";
const CHECKBOX_TAG_SELECTOR = `input[type="checkbox"]${BASE_SELECTOR}`;

const handleCheckAllInGroup = (checked: boolean, group: string): void => {
  const itemsInGroup = document.querySelectorAll<HTMLInputElement>(
    `[txu-group="${group}"]`
  );
  itemsInGroup.forEach((item) => {
    if (!item.disabled) {
      item.checked = checked;
    }
  });
};

const handleToggleGroupControlState = (group: string): void => {
  const itemsInGroup = document.querySelectorAll<HTMLInputElement>(
    `[txu-group="${group}"]`
  );
  const controls = document.querySelectorAll<HTMLInputElement>(
    `[txu-toggle-group="${group}"]`
  );

  if (!controls.length) return;
  if (!itemsInGroup.length) {
    // If there are no items in the group, therefore the control has no effect and should be disabled
    controls.forEach((control) => {
      control.checked = false;
      control.indeterminate = false;
      control.disabled = true;
    });
    return;
  }
  let amountChecked = 0;
  let totalDisabledItems = 0;
  itemsInGroup.forEach((item) => {
    if (item.checked) {
      amountChecked++;
    }
    if (item.disabled) totalDisabledItems++;
  });

  const relevantLength = itemsInGroup.length - totalDisabledItems;
  const newChecked = amountChecked >= relevantLength;
  const newIndeterminate = amountChecked > 0 && amountChecked < relevantLength;

  // Update all controls with the same group to stay in sync
  controls.forEach((control) => {
    control.checked = newChecked;
    control.indeterminate = newIndeterminate;
    control.disabled = false;
  });
};

/*
  Disable a checkbox option in a group of checkboxes based on selectedValue
*/
const toggleDisabledState = (
  selectedValue: string,
  groupName: string,
  element: Element | Document
): void => {
  const groups = element.querySelectorAll<HTMLInputElement>(
    `[txu-group="${groupName}"]`
  );
  groups.forEach((group) => {
    if (group.value === selectedValue) {
      group.checked = false;
      group.disabled = true;
      group.parentElement.classList.add("tw-text-gray-400");
    } else {
      group.disabled = false;
      group.parentElement.classList.remove("tw-text-gray-400");
    }
  });
};

export const loadCheckboxTagHandlers = (element: Element | Document): void => {
  const checkboxes = element.querySelectorAll(CHECKBOX_TAG_SELECTOR);

  /*
    If a element has txu-handler="disable-checkbox", the value of that element is used to disable a checkbox option in a group of checkboxes.
  */
  const disableControls = element.querySelectorAll(
    `${BASE_SELECTOR}${DISABLE_VALUE_SELECTOR}`
  );
  if (disableControls) {
    disableControls.forEach((control) => {
      const selectedValue = (control as HTMLSelectElement).value;
      const groupName = control.getAttribute("txu-toggle-group");
      toggleDisabledState(selectedValue, groupName, element);
      control.addEventListener("change", () => {
        const selectedValue = (control as HTMLSelectElement).value;
        const groupName = control.getAttribute("txu-toggle-group");
        toggleDisabledState(selectedValue, groupName, element);
      });
    });
  }

  checkboxes.forEach((checkbox) => {
    const group = checkbox.getAttribute("txu-toggle-group");
    if (group) {
      handleToggleGroupControlState(group);
      checkbox.addEventListener("change", (event) => {
        const checked = (event.target as HTMLInputElement).checked;
        handleCheckAllInGroup(checked, group);
        // Sync all other checkboxes with the same txu-toggle-group
        const allToggleCheckboxes = document.querySelectorAll<HTMLInputElement>(
          `[txu-toggle-group="${group}"]`
        );
        allToggleCheckboxes.forEach((toggleCheckbox) => {
          if (toggleCheckbox !== checkbox) {
            toggleCheckbox.checked = checked;
            toggleCheckbox.indeterminate = false;
          }
        });
      });
      const itemsInGroup = document.querySelectorAll<HTMLInputElement>(
        `[txu-group="${group}"]`
      );
      itemsInGroup.forEach((item) => {
        item.addEventListener("change", () => {
          handleToggleGroupControlState(group);
        });
      });
    }
  });
};
